/* eslint-disable */
export const dialogs = {
    namespaced: true,
    state: {
        loginDialog: false,
        registerDialog: false,
        createDialog: false,
        createProductDialog: false,
        createClientDialog: false,
        createProviderDialog: false,
        createShopDialog: false,
        createCategoryDialog: false,
        createTransferDialog: false,
        createPurchaseDialog: false,
        createExpensesDialog: false,
        currentItem: null,
        webRTC: null,
        paymentWizDialog: false,
        tutorial: false,
        tutorialVideo: '',
    },
    mutations: {
        SET_LOGIN_DIALOG (state, payload) {
          state.loginDialog = payload
        },
        SET_REGISTER_DIALOG (state, payload) {
          state.registerDialog = payload
        },
        SET_CREATE_PRODUCT_DIALOG (state, payload) {
            state.createProductDialog = payload
        },
        SET_CREATE_CLIENT_DIALOG (state, payload) {
            state.createClientDialog = payload
        },
        SET_CREATE_PROVIDER_DIALOG (state, payload) {
            state.createProviderDialog = payload
        },
        SET_CREATE_CATEGORY_DIALOG (state, payload) {
            state.createCategoryDialog = payload
        },
        SET_CREATE_SHOP_DIALOG (state, payload) {
            state.createShopDialog = payload
        },
        SET_TRANSFER_DIALOG (state, payload) {
            state.createTransferDialog = payload
        },
        SET_PURCHASE_DIALOG (state, payload) {
            state.createPurchaseDialog = payload
        },
        SET_EXPENSES_DIALOG (state, payload) {
            state.createExpensesDialog = payload
        },
        SET_CREATE_DIALOG (state, payload) {
            state.createDialog = payload
        },
        SET_WEBRTC_DIALOG (state, payload) {
            state.webRTC = payload
        },
        SET_PAYMENTWIZ_DIALOG (state, payload) {
            state.paymentWizDialog = payload
        },
        SET_CURRENT_DIALOG (state, payload) {
            state.currentItem = payload
        },
        SET_TUTORIAL_DIALOG (state, payload) {
            state.tutorial = payload
        },
        SET_TUTORIAL_VIDEO (state, payload) {
            state.tutorialVideo = payload
        },
    },

    actions: {
        openDialog ({ commit, state }, payload) {
            // console.log(payload)
            let setCommit
            switch (payload) {
                case 'login':
                    setCommit = 'SET_LOGIN_DIALOG'
                    break
                case 'register':
                    setCommit = 'SET_REGISTER_DIALOG'
                    break
                case 'createProduct':
                    setCommit = 'SET_CREATE_PRODUCT_DIALOG'
                    break
                case 'createClient':
                    setCommit = 'SET_CREATE_CLIENT_DIALOG'
                    break
                case 'createProvider':
                    setCommit = 'SET_CREATE_PROVIDER_DIALOG'
                    break
                case 'createCategory':
                    setCommit = 'SET_CREATE_CATEGORY_DIALOG'
                    break
                case 'createShop':
                    setCommit = 'SET_CREATE_SHOP_DIALOG'
                    break
                case 'createTransfer':
                    setCommit = 'SET_TRANSFER_DIALOG'
                    break
                case 'createPurchase':
                    setCommit = 'SET_PURCHASE_DIALOG'
                    break
                case 'createExpenses':
                    setCommit = 'SET_EXPENSES_DIALOG'
                case 'webRTC':
                    setCommit = 'SET_WEBRTC_DIALOG'
                    break
                case 'paymentWizDialog':
                    setCommit = 'SET_PAYMENTWIZ_DIALOG'
                    break
                case 'tutorialDialog':
                    setCommit = 'SET_TUTORIAL_DIALOG'
                    break
            }
            commit('SET_CURRENT_DIALOG', payload)
            commit(setCommit, true)
        },
        closeDialog ({ commit }, payload) {
            let setCommit
            switch (payload) {
                case 'login':
                    setCommit = 'SET_LOGIN_DIALOG'
                    break
                case 'register':
                    setCommit = 'SET_REGISTER_DIALOG'
                    break
                case 'createProduct':
                    setCommit = 'SET_CREATE_PRODUCT_DIALOG'
                    break
                case 'createCategory':
                    setCommit = 'SET_CREATE_CATEGORY_DIALOG'
                    break
                case 'createShop':
                    setCommit = 'SET_CREATE_SHOP_DIALOG'
                    break
                case 'createTransfer':
                    setCommit = 'SET_TRANSFER_DIALOG'
                    break
                case 'createPurchase':
                    setCommit = 'SET_PURCHASE_DIALOG'
                    break
                case 'webRTC':
                    setCommit = 'SET_WEBRTC_DIALOG'
                    break
                case 'paymentWizDialog':
                    setCommit = 'SET_PAYMENTWIZ_DIALOG'
                    break
                case 'tutorialDialog':
                    setCommit = 'SET_TUTORIAL_DIALOG'
                    break
            }
            // console.log(setCommit)
            commit('SET_CURRENT_DIALOG', null)
            commit(setCommit, false)
        },
        openCreateDialog ({ commit, state }) {
            if (state.createDialog) { commit('SET_CREATE_DIALOG', false) } else commit('SET_CREATE_DIALOG', true)
        },
        closeCreateDialog ({ commit, state }) {
            if (state.createDialog === true) { commit('SET_CREATE_DIALOG', false) }
        },
        setTutorialVideo ({ commit, state }, payload) {
            // console.log(payload)
            let currentVideo
            switch (payload) {
                case 'shop':
                    currentVideo = 'https://www.youtube.com/embed/G6McegTj7sY'
                    break
                case 'inventory':
                    currentVideo = 'https://www.youtube.com/embed/pBvTsLYsiHY'
                    break
                case 'sales':
                    currentVideo = 'https://www.youtube.com/embed/bEl-cRU5eS0'
                    break
                default:
                    currentVideo = 'https://www.youtube.com/embed/elNsCVJ3p_k'
                    break;
            }
            commit('SET_TUTORIAL_VIDEO', currentVideo)
        },

    },
    getters: {
        getDialog (state, payload) {
            switch (payload) {
                case 'login':
                    return state.loginDialog
                    break
                case 'register':
                    return state.registerDialog
                    break
                case 'createProduct':
                    return state.createProductDialog
                    break
                case 'createClient':
                    return state.createClientDialog
                    break
                case 'createProvider':
                    return state.createProviderDialog
                    break
                case 'createCategory':
                    return state.createCategoryDialog
                    break
                case 'createShop':
                    return state.createShopDialog
                    break
                case 'createTransfer':
                    return state.createTransferDialog
                    break
                case 'createPurchase':
                    return state.createPurchaseDialog
                    break
                case 'createExpenses':
                    return state.createExpensesDialog
                case 'webRTC':
                    return state.webRTC
                    break
                case 'tutorial':
                    return state.tutorial
                break
            }
        },
        getPaymentWizzardDialog (state) {
          return state.paymentWizDialog
        },
        getCurrentItem (state) {
          return state.currentItem
        },
        getCreateDialog (state) {
            return state.createDialog
        },
    },

}
